import React from 'react';

interface CountdownModalProps {
  show: boolean;
  countdownValue: number;
}

const CountdownModal = ({ show, countdownValue }: CountdownModalProps) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="bg-white rounded-lg p-8 z-10 text-center shadow-xl transform transition-all scale-in">
        <h2 className="text-2xl font-bold mb-4 text-indigo-700">Get ready to write!</h2>
        <div className="w-28 h-28 rounded-full bg-indigo-600 text-white text-6xl font-bold mx-auto mb-4 flex items-center justify-center shadow-lg transform animate-pulse">
          {countdownValue}
        </div>
        <p className="text-gray-600 text-lg">
          Your writing session will begin in <span className="font-semibold">{countdownValue}</span> second{countdownValue !== 1 ? 's' : ''}
        </p>
        <p className="mt-2 text-sm text-gray-500 italic">
          Remember: keep typing continuously or your text will be deleted
        </p>
      </div>
    </div>
  );
};

export default CountdownModal; 